import script from "./BillingCover.vue?vue&type=script&setup=true&lang=ts"
export * from "./BillingCover.vue?vue&type=script&setup=true&lang=ts"

import "./BillingCover.vue?vue&type=style&index=0&id=4781b8ee&scoped=true&lang=css"

import exportComponent from "/home/runner/work/onino-app/onino-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4781b8ee"]])

export default __exports__